export const sampleClients = [
  {
    id: 1,
    name: "Sarah Johnson",
    age: 28,
    gender: "female",
    weight: 65,
    height: 168,
    goal: "cutting",
    activityLevel: "moderate",
    startWeight: 70,
    targetWeight: 60,
    startDate: "2024-01-15",
    measurements: {
      waist: 75,
      hips: 95,
      neck: 32
    }
  },
  {
    id: 2,
    name: "Mike Chen",
    age: 32,
    gender: "male",
    weight: 80,
    height: 178,
    goal: "bulking",
    activityLevel: "active",
    startWeight: 75,
    targetWeight: 85,
    startDate: "2024-02-01",
    measurements: {
      waist: 85,
      neck: 38
    }
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    age: 25,
    gender: "female",
    weight: 58,
    height: 162,
    goal: "maintenance",
    activityLevel: "light",
    startWeight: 58,
    targetWeight: 58,
    startDate: "2024-01-01",
    measurements: {
      waist: 68,
      hips: 88,
      neck: 30
    }
  }
];

export const progressData = [
  { date: "2024-01-15", weight: 70, bodyFat: 22.5 },
  { date: "2024-01-22", weight: 69.2, bodyFat: 22.1 },
  { date: "2024-01-29", weight: 68.8, bodyFat: 21.8 },
  { date: "2024-02-05", weight: 68.1, bodyFat: 21.4 },
  { date: "2024-02-12", weight: 67.5, bodyFat: 21.0 },
  { date: "2024-02-19", weight: 67.0, bodyFat: 20.7 },
  { date: "2024-02-26", weight: 66.3, bodyFat: 20.3 },
  { date: "2024-03-04", weight: 65.8, bodyFat: 20.0 },
  { date: "2024-03-11", weight: 65.4, bodyFat: 19.8 },
  { date: "2024-03-18", weight: 65.0, bodyFat: 19.5 }
];

export const foodDatabase = [
  { id: 1, name: "Chicken Breast", calories: 165, protein: 31, carbs: 0, fat: 3.6, serving: "100g" },
  { id: 2, name: "Brown Rice", calories: 111, protein: 2.6, carbs: 23, fat: 0.9, serving: "100g" },
  { id: 3, name: "Broccoli", calories: 34, protein: 2.8, carbs: 7, fat: 0.4, serving: "100g" },
  { id: 4, name: "Salmon", calories: 208, protein: 22, carbs: 0, fat: 12, serving: "100g" },
  { id: 5, name: "Sweet Potato", calories: 86, protein: 1.6, carbs: 20, fat: 0.1, serving: "100g" },
  { id: 6, name: "Avocado", calories: 160, protein: 2, carbs: 9, fat: 15, serving: "100g" },
  { id: 7, name: "Greek Yogurt", calories: 59, protein: 10, carbs: 3.6, fat: 0.4, serving: "100g" },
  { id: 8, name: "Almonds", calories: 579, protein: 21, carbs: 22, fat: 50, serving: "100g" },
  { id: 9, name: "Oats", calories: 389, protein: 17, carbs: 66, fat: 7, serving: "100g" },
  { id: 10, name: "Eggs", calories: 155, protein: 13, carbs: 1.1, fat: 11, serving: "100g" }
];

export const sampleMeals = [
  {
    id: 1,
    name: "Breakfast",
    foods: [
      { food: foodDatabase[9], quantity: 50 }, // Oats
      { food: foodDatabase[6], quantity: 150 }, // Greek Yogurt
      { food: foodDatabase[7], quantity: 20 } // Almonds
    ]
  },
  {
    id: 2,
    name: "Lunch",
    foods: [
      { food: foodDatabase[0], quantity: 150 }, // Chicken Breast
      { food: foodDatabase[1], quantity: 100 }, // Brown Rice
      { food: foodDatabase[2], quantity: 100 } // Broccoli
    ]
  },
  {
    id: 3,
    name: "Dinner",
    foods: [
      { food: foodDatabase[3], quantity: 120 }, // Salmon
      { food: foodDatabase[4], quantity: 150 }, // Sweet Potato
      { food: foodDatabase[5], quantity: 50 } // Avocado
    ]
  }
];

export const activityLevels = [
  { value: 'sedentary', label: 'Sedentary (desk job, no exercise)', multiplier: 1.2 },
  { value: 'light', label: 'Light (exercise 1-3 days/week)', multiplier: 1.375 },
  { value: 'moderate', label: 'Moderate (exercise 3-5 days/week)', multiplier: 1.55 },
  { value: 'active', label: 'Active (exercise 6-7 days/week)', multiplier: 1.725 },
  { value: 'veryActive', label: 'Very Active (2x/day, intense)', multiplier: 1.9 },
  { value: 'athlete', label: 'Athlete (professional training)', multiplier: 2.2 }
];

export const goals = [
  { value: 'cutting', label: 'Fat Loss (Cutting)', description: 'Lose weight and reduce body fat' },
  { value: 'bulking', label: 'Muscle Gain (Bulking)', description: 'Gain weight and build muscle' },
  { value: 'maintenance', label: 'Maintenance', description: 'Maintain current weight' }
];